/* eslint-disable */
// Módulo para obtener el estado de los filtros seleccionados

const state = {
  filters: {
    suprazone: null,
    group: 0,
    date: null
  }
}

const actions = {

  updateFilters(context, filtersData) {
    context.commit('UPDATE_FILTERS', filtersData)
  },

  resetFilters({commit}) {
    commit ('RESET_FILTERS')
  },

}
const mutations = {

  UPDATE_FILTERS(state, filtersData) {
    state.filters = filtersData
  },

  RESET_FILTERS(state) {
    state.filters = []
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
